export function formatPrice(value) {
  const parsed = Number(value || 0);
  const amount = Number.isFinite(parsed) ? Math.round(parsed * 100) / 100 : 0;
  return `${new Intl.NumberFormat("uz-UZ", {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  }).format(amount)} so'm`;
}


export function buildAccent(index = 0) {
  const accents = [
    "sunset",
    "forest",
    "ocean",
    "ember",
    "plum",
    "sand",
  ];
  return accents[index % accents.length];
}


export function buildFallbackLabel(value = "") {
  return String(value || "?").slice(0, 1).toUpperCase();
}
